export const getDate = (date: string) => new Date(date).toDateString();
